export const POMPEYO_BUSINESS_UNIT_ID = 2;
export const SALFA_USED_ID = 3;
export const SALFA_NURTURING_ID = 8;
export const SALFA_RAC_EXT_BUSINESS_UNIT_ID = 33;
export const SALFA_RAC_AEROPUERTO_BUSINESS_UNIT_ID = 188;
export const INSUREX_BUSINESS_UNIT_ID = 39;
export const BRUNO_FRITSCH_BUSINESS_UNIT_ID = 22;
export const AUTOLAND_VENTAS_BUSINESS_UNIT_ID = 45;
export const AUTOLAND_COLOMBIA_VENTAS_BUSINESS_UNIT_ID = 132;
export const AUTOSRELIF_BUSINESS_UNIT_ID = 79;
export const SALFA_SERVICIO_LIVIANO_BUSINESS_UNIT_ID = 152;
export const KOVACS_BUSINESS_UNIT_ID = 109;
export const PIAMONTE_BUSINESS_UNIT_ID = 96;
export const GAMA_MOBILITY_BUSINESS_UNIT_ID = 133;
export const BRAVOAUTO_BUSINESS_UNIT_ID = 167;

const BANCO_INTERNACIONAL_REFI_ROBOT_BUSINESS_UNIT_ID = 38;
export const BCI_REFI_ROBOT_BUSINESS_UNIT_ID = 78;
const BUK_REFI_ROBOT_BUSINESS_UNIT_ID = 73;
const SCOTIABANK_REFI_ROBOT_BUSINESS_UNIT_ID = 129;

export const FINANCIAL_INSTITUTION_BUSINESS_UNIT_IDS = [
  BANCO_INTERNACIONAL_REFI_ROBOT_BUSINESS_UNIT_ID,
  BCI_REFI_ROBOT_BUSINESS_UNIT_ID,
  BUK_REFI_ROBOT_BUSINESS_UNIT_ID,
  SCOTIABANK_REFI_ROBOT_BUSINESS_UNIT_ID,
];

// Salfa Rent a Car runs on two BUs sharing one WhatsApp number: BU 33 (rental) and BU 188 (aeropuerto).
export const SALFA_RAC_BUSINESS_UNIT_IDS = [SALFA_RAC_EXT_BUSINESS_UNIT_ID, SALFA_RAC_AEROPUERTO_BUSINESS_UNIT_ID];

// Business units that use the shared-pool client-queue tabs
export const POOL_QUEUE_TAB_BUSINESS_UNIT_IDS = [
  SALFA_RAC_EXT_BUSINESS_UNIT_ID,
  SALFA_RAC_AEROPUERTO_BUSINESS_UNIT_ID,
  GAMA_MOBILITY_BUSINESS_UNIT_ID,
];

export const RELIF_META_APP_ID = '751934229868983';
export const RELIF_META_EMBEDDED_SIGNUP_CONFIG_ID = '4450181631898766';
